"use client";

import * as React from "react";
import { ShoppingCart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useCartStore, selectTotalItems } from "@/lib/cart/cart-store";
import { useMediaQuery } from "@/hooks/use-media-query";
import CartDetailsSheet from "@/components/cart/cart-details-sheet";

export default function CartButton() {
  const totalItems = useCartStore(selectTotalItems);
  const isDesktop = useMediaQuery("(min-width: 768px)");
  const [isSheetOpen, setIsSheetOpen] = React.useState(false);

  const handleClick = () => {
    setIsSheetOpen(true);
  };

  React.useEffect(() => {
    if (!isDesktop) setIsSheetOpen(false);
  }, [isDesktop]);

  return (
    <>
      <Button variant="ghost" size="icon" className="relative ml-4 h-12 w-12 cursor-pointer" onClick={handleClick}>
        <ShoppingCart className="h-6 w-6 scale-125" />
        {totalItems > 0 && (
          <Badge
            className="
              absolute -right-1 -top-1
              h-6 min-w-[1.5rem]
              rounded-full px-1.5
              flex items-center justify-center
              bg-teal-400 text-white
            "
          >
            {totalItems}
          </Badge>
        )}
      </Button>
      <CartDetailsSheet open={isSheetOpen} onOpenChange={setIsSheetOpen} />
    </>
  );
}
